import { Spin, Typography } from 'antd';
import React from 'react';
import DownloadChecklistPdfForm from '../Form/download_checklist_pdf';
const { Paragraph } = Typography;

export const ChecklistPdfDetail = ({ checklistDetail, handleBackToResult }) => {
	return (
		<Spin spinning={false} size="large">
			<div className="detail-checklist">
				<div className="detail-checklist__heading">
					<div className="detail-checklist__title-wrapper">
						<div className="detail-checklist__back-link" onClick={handleBackToResult}>
							Back to Search Results
						</div>
						<div className="detail-checklist__title">{checklistDetail.title}</div>
						<div className="detail-checklist__desc">
							<Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'more' }}>
								{checklistDetail.description}
							</Paragraph>
						</div>
					</div>

					<div className="detail-checklist__btn-wrapper">
						<DownloadChecklistPdfForm
							classNameBtn="btn btn--checklist"
							checklist={checklistDetail}
							isChecklistGenerator={true}
						/>
					</div>
				</div>

				{checklistDetail.file && (
					<div className="detail-checklist__review-pdf">
						<iframe
							src={`data:application/pdf;base64, ${checklistDetail.file}#toolbar=0&navpanes=0&scrollbar=0`}
							className="detail-checklist__review-pdf"
							loading="lazy"
						/>
					</div>
				)}
			</div>
		</Spin>
	);
};
